// extracted by mini-css-extract-plugin
module.exports =  {"about-me":"QAl9kAF","aboutMe":"QAl9kAF","title":"IOSHcAX","description":"vxWK_SR","clamp":"NATTdMg"};